import {
    GET_TEAMS_SUCCESS,
    GET_TEAMS_FAIL,
    GET_TEAMS,
    POST_TEAM,
    POST_TEAM_FAIL,
} from "./actionTypes";

// teams data

export const getTeams = () => ({
  type: GET_TEAMS,
})

export const getTeamsSuccess = teams => ({
  type: GET_TEAMS_SUCCESS,
  payload: teams,
})

export const getTeamsFail = error => ({
  type: GET_TEAMS_FAIL,
  payload: error,
})

export const postTeam = (team, history) => {
  return {
    type: POST_TEAM,
    payload: { team, history }
  }
}

export const postTeamFail = error => ({
  type: POST_TEAM_FAIL,
  payload: error,
})